export class PromiseUtils {
  public static timeoutPromise(timeoutDuration: number) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        reject(new Error('Promise timed out'))
      }, timeoutDuration)
    })
  }
}
